export class AMOUNTS {

  public static LIST: number[] = [10000, 25000, 50000, 75000, 100000, 150000];

}
